// 사진 큰 보기 — 서명 URL 을 그대로 띄우는 오버레이 (시안 A3 사진 클릭).
// 서명 쿼리가 붙은 원본 URL 이라 별도 조립·다운로드 경로를 만들지 않는다.
// props: { src, alt, onClose }
import React, { useEffect } from 'react';
import { T, R } from '../../../theme';
import { useT } from '../../../../i18n/I18nProvider';

var dim = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,.82)', zIndex: 9995,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 };
var img = { maxWidth: '100%', maxHeight: '86vh', borderRadius: R.md, objectFit: 'contain' };
var close = { position: 'absolute', top: 14, insetInlineEnd: 16, height: 32, padding: '0 12px', borderRadius: R.pill,
  border: '1px solid ' + T.bd, background: T.card, color: T.body, fontSize: 12.5, fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit' };

function Lightbox(props) {
  var t = useT();
  var onClose = props.onClose;
  useEffect(function () {
    var h = function (e) { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', h);
    return function () { document.removeEventListener('keydown', h); };
  }, [onClose]);
  if (!props.src) return null;
  return (<div className="ss-lightbox" style={dim}
    onClick={function (e) { if (e.target === e.currentTarget && onClose) onClose(); }}>
    <button type="button" style={close} onClick={onClose}>{t('actionClose')}</button>
    <img src={props.src} alt={props.alt || ''} style={img} />
  </div>);
}

export default Lightbox;
